module.exports = __webpack_public_path__ + "img/It-T600.43be9bf3.gif";